import { writable, type Writable } from 'svelte/store';

export const menuOpen: Writable<boolean> = writable(false);
export const hideStickyButtons: Writable<boolean> = writable(false);
